import React from "react";

const ConnectedButton = (props) => {
  const { isConnected } = props;

  return (
    <button className={isConnected ? "connected" : "not-connected"}>
      {isConnected ? "Connecté" : "Non connecté"}
    </button>
  );
};

export default ConnectedButton;
